module.exports = __webpack_public_path__ + "static/media/freshchat-logo.e4e8dfa4.svg";